/*  ========================================================================
    # Sections - Posts
    ========================================================================  */

import React from 'react';
import PropTypes from 'prop-types';
import Card from '../../components/Card';
import { motion, AnimatePresence } from 'motion/react';

const PickedPosts = ({
  intro,
  readMoreLink,
  posts,
  semanticHeadlineLevel
}) => {
  return (
    <>
      <div className='container'>
        <div className='s-picked-posts__wrapper'>
          {intro || readMoreLink ? (
            <div className='s-picked-posts__intro'>
              {intro && (
                <div className='s-picked-posts__content wysiwyg-block' dangerouslySetInnerHTML={{ __html: intro }} />
              )}
              {readMoreLink && (
                <a className='s-picked-posts__read-more c-button c-button--chevron-right' target={readMoreLink.target} href={readMoreLink.url} aria-label={readMoreLink.title}>
                  {readMoreLink.title}
                </a>
              )}

            </div>
          ) : null}

          <div className='s-picked-posts__list'>
            <AnimatePresence>
              {posts.map(post => (
                <motion.div className='s-picked-posts__list-item' layout='position' key={post.id}>
                  <Card
                    image={post.image}
                    title={post.title}
                    label={post.label}
                    buttonTranslationString={post.buttonTranslationString}
                    link={post.link}
                    metaString={post.metaString}
                    date={post.postType === 'contract_casestudy' ? '' : post.date}
                    location={post.location}
                    semanticHeadlineLevel={semanticHeadlineLevel}
                  />
                </motion.div>
              ))}
            </AnimatePresence>
          </div>
        </div>
      </div>
    </>
  );
};

PickedPosts.propTypes = {
  intro: PropTypes.string,
  readMoreLink: PropTypes.array,
  posts: PropTypes.array,
  semanticHeadlineLevel: PropTypes.string
};

export default PickedPosts;
